import * as React from 'react';
import { observer } from 'mobx-react';
import PersonPhoto from '../PersonPhoto';
import { currentUserStore } from '../../CurrentUserStore';

const Person: React.FC = () => (
  <div className="flex" data-test-person={true}>
    <div
      className="relative h-10 w-10 min-w-[100%] rounded-full bg-[#187A90]"
      data-test-person-avatar={true}
    >
      <PersonPhoto avatar={currentUserStore.avatar} />
    </div>
  </div>
);

export default observer(Person);
